import Swiper, { Navigation, Pagination } from 'swiper';
import mobileCarousel from '../utils/mobileCarousel';
import SectionPagination from '../modules/pagination/pagination';

const awardsSection = document.querySelectorAll('.awards-section');

if (awardsSection && awardsSection.length > 0) {
    const mobileSections = document.querySelectorAll(
        '.awards-section__items--mobile'
    );

    if (mobileSections && mobileSections.length > 0) {
        mobileCarousel(
            'awards-section__items--mobile',
            'swiper-pagination-awards-section',
            1.2,
            16,
            false
        );
    } else {
        const desktopCarousels = document.querySelectorAll(
            '.awards-section__items--desktop'
        );
        Swiper.use([Pagination, Navigation]);
        let slidersArray = [];
        desktopCarousels.forEach((section, i) => {
            let init = false;
            const ogSlider = section.classList.contains('-og')
                ? section.querySelector('.awards-section__pagination-wrapper')
                : false;
            if (!init) {
                init = true;
                if (section.querySelector('.swiper-wrapper')) {
                    const carousel = new Swiper(section, {
                        slideActiveClass: 'is-active',
                        breakpoints: {
                            0: {
                                slidesPerView: 1.4,
                                spaceBetween: 16,
                            },
                            992: {
                                slidesPerView: 3,
                                spaceBetween: 24,
                            },
                        },
                        pagination: {
                            el: ogSlider,
                            type: 'bullets',
                            bulletClass:
                                'bottom-pagination__bullet awards-section__bullet',
                            bulletActiveClass: 'active',
                        },
                        navigation: {
                            nextEl: section.parentElement.querySelector(
                                '.slider-arrow--next'
                            ),
                            prevEl: section.parentElement.querySelector(
                                '.slider-arrow--prev'
                            ),
                        },
                    });
                    slidersArray.push(carousel);
                }
            }
        });
    }
    awardsSection.forEach(section => {
        const dynamicList = section.querySelector('.awards-section__items--dynamic');
        const loaderEl = section.querySelector('.awards-section__loader');
        const awardCardsPlaceholder = section.querySelectorAll(
            '.card-award--placeholder'
        );
        let awardCardsOg = section.querySelectorAll('.card-award--og');

        let paginationInstance = null;
        let maxPages = parseInt(section.querySelector('input[name="max_pages"]').value);
        let currPage = 1;
        let highestElement = 0;

        const handleElementHeight = () => {
            const ogSliderWidth = section.querySelector(
                '.awards-section__items.-og'
            ).offsetWidth;
            section.querySelector(
                '.awards-section__items.-placeholder'
            ).style.width = `${ogSliderWidth}px`;

            highestElement = 0;

            setTimeout(() => {
                awardCardsPlaceholder.forEach(card => {
                    const topElementHeight =
                        card.querySelector('.card-award__top').offsetHeight;
                    const titleHeight =
                        card.querySelector('.card-award__title').offsetHeight;
                    const total = topElementHeight + titleHeight;

                    if (total > highestElement) {
                        highestElement = total;
                    }
                });

                awardCardsOg.forEach(card => {
                    card.style.height = `${highestElement + 40}px`;
                });
            }, 100);
        };

        const handleCardMouseOver = e => {
            const { currentTarget } = e;
            currentTarget.classList.add('hover');
            const topElement = currentTarget.querySelector('.card-award__top');
            const bottomElementsHeight = currentTarget.querySelector(
                '.card-award__bottom'
            ).offsetHeight;
            topElement.style.maxHeight = `${
                highestElement - bottomElementsHeight + 40
            }px`;
        };

        const handleCardMouseOut = e => {
            const { currentTarget } = e;
            currentTarget.classList.remove('hover');
            const topElement = currentTarget.querySelector('.card-award__top');
            topElement.style.maxHeight = '5000px';
        };

        const initAwardsDynamicList = (dynamicList, section) => {
            const pagination = section.querySelector('.pagination');
            if (pagination) setPagination(pagination, section);
        }

        const loadAwards = async (currPage, wrapperEl) => {
            wrapperEl.classList.add('loading');
            loaderEl.classList.remove('d-none');

            try {
                const formData = new FormData();
    
                formData.append('action', 'awards_list');
                formData.append('page', currPage);
    
                const req = await fetch(ajax.url, {
                    body: formData,
                    method: 'POST',
                });
    
                const res = await req.json();
    
                const { max_pages, html } = res;
                maxPages = parseInt(max_pages);
    
                wrapperEl.innerHTML = html;
                paginationInstance.reset(currPage, maxPages);

                handleElementHeight();
                awardCardsOg = section.querySelectorAll('.card-award--og');
                awardCardsOg.forEach(card => {
                    card.addEventListener('mouseover', handleCardMouseOver);
                    card.addEventListener('mouseout', handleCardMouseOut);
                });

                section.scrollIntoView();
                wrapperEl.classList.remove('loading');
                loaderEl.classList.add('d-none');
            } catch (error) {
                console.log(`error: ${error}`);
            }
        }

        const setPagination = (paginationEl, section) => {
            if (!paginationEl) return;
    
            paginationInstance = new SectionPagination(paginationEl, section);
            section.addEventListener('pagination-change', e => {
                const wrapperEl = dynamicList.querySelector('.awards-section__row');
                const { detail } = e;
                currPage = detail;
    
                if (currPage < 1) {
                    currPage = 1;
                    return;
                }
    
                if (currPage > maxPages) {
                    currPage = maxPages;
                    return;
                }

                loadAwards(currPage, wrapperEl);
            });
        }

        window.addEventListener('resize', () => {
            handleElementHeight();
        });
        handleElementHeight();

        awardCardsOg.forEach(card => {
            card.addEventListener('mouseover', handleCardMouseOver);
            card.addEventListener('mouseout', handleCardMouseOut);
        });

        if (dynamicList) initAwardsDynamicList(dynamicList, section);
    });
}
